"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../helpers/api.js");
var _dateTime = require("../helpers/dateTime.js");
var _constants = require("../constants");
var CmeTracker = /*#__PURE__*/_createClass(function CmeTracker(api, cme) {
  var _this = this;
  _classCallCheck(this, CmeTracker);
  this.cmeTrackersFetchKey = function () {
    var questionBankId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
    return "cme-trackers/".concat(questionBankId);
  };
  this.cmeTrackersFetch = function (questionBankId) {
    return function (dispatch, getState) {
      var _getState = getState(),
        loading = _getState.loading,
        loadedAt = _getState.loadedAt;
      var key = _this.cmeTrackersFetchKey(questionBankId);
      if (loading.has(key)) return loading.get(key);

      // Get load keys for prerequisite actions
      var activitiesKey = _this.cme.cmeActivitiesFetch.getKey(questionBankId);

      // Check that prerequisite actions are loaded and call them if they haven't been
      if (!loadedAt.has(activitiesKey) || (0, _dateTime.hasBeenADaySince)(loadedAt.get(activitiesKey))) dispatch(_this.cme.cmeActivitiesFetch(questionBankId));

      // Check if prerequisite actions are loading so that we can wait for them to finish
      var _getState2 = getState();
      loading = _getState2.loading;
      var questionBankParam = questionBankId ? "question_banks/".concat(questionBankId, "/") : '';
      var promises = [_this.api.get("".concat((0, _api.currentUserUrl)(getState()), "/").concat(questionBankParam, "cme_trackers"))];
      if (loading.has(activitiesKey)) promises.push(loading.get(activitiesKey));
      if (promises.length < 1) return Promise.resolve({});
      var promise = Promise.all(promises).then(function (responses) {
        dispatch({
          type: _constants.CME_TRACKER_FETCHED,
          payload: _objectSpread({
            key: key
          }, responses[0])
        });
        return responses[0];
      }).catch(function (error) {
        dispatch({
          type: _constants.CME_TRACKER_ERROR,
          payload: {
            error: error,
            key: key
          }
        });
        throw error;
      });
      dispatch({
        type: _constants.CME_TRACKER_LOADING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.api = api;
  this.cme = cme;
});
var _default = exports.default = CmeTracker;